import { Link } from 'react-router-dom';
import { BadgeCheck, Store } from 'lucide-react';
import WishlistButton from './WishlistButton';

const rs = (n) => `₹${Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;

export default function CatalogCard({ p }) {
  const off = p.best_price && p.mrp > p.best_price ? Math.round(((p.mrp - p.best_price) / p.mrp) * 100) : 0;
  return (
    <Link to={`/p/${p.slug}`} data-testid={`catalog-card-${p.slug}`} className="card-soft overflow-hidden group block">
      <div className="aspect-square bg-white overflow-hidden relative">
        <WishlistButton cpId={p.id} className="absolute top-2 right-2 z-10"/>
        <img src={p.images?.[0]} alt={p.name} loading="lazy" className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"/>
      </div>
      <div className="p-3 space-y-1">
        <div className="text-xs text-ink/60 flex items-center gap-1">{p.brand}{p.brand_id && <BadgeCheck className="w-3.5 h-3.5 text-[#1B5E20]"/>}</div>
        <div className="font-semibold text-sm line-clamp-2 min-h-[2.5rem]">{p.name}</div>
        {p.best_price ? (
          <div className="flex items-baseline gap-2">
            <span className="font-heading font-bold text-lg">{rs(p.best_price)}</span>
            {off > 0 && <><span className="text-xs line-through text-ink/50">{rs(p.mrp)}</span><span className="text-xs font-bold text-[#1B5E20]">{off}% off</span></>}
          </div>
        ) : <div className="text-sm text-ink/50">Currently unavailable</div>}
        {p.offer_count > 1 && <div className="text-xs text-[#D35400] flex items-center gap-1"><Store className="w-3 h-3"/>{p.offer_count} sellers</div>}
      </div>
    </Link>
  );
}
